// lib/video-loop-tiers.ts
// Single source of truth for the video self-validation loop tiers (video-loop plan
// Phase 2/3). A generation model is either a cheap i2v "motion" validator or a SOTA
// "render" final; the composer telemetry, timeline pending track, and film-route
// RUNNING socket all label the running stage from this one mapping.

type VideoLoopTier = 'motion' | 'render';

export const videoLoopTier = (modelId: string | null | undefined): VideoLoopTier | null => {
  switch ((modelId ?? '').trim()) {
    case 'hailuo-02-fast':
    case 'wan-2.2-i2v':
    case 'wan-2.2-fast':
    case 'flux-3-draft':
      return 'motion';
    case 'seedance-2.0':
    case 'seedance-2.0-fast':
    case 'seedance-2.5':
    case 'flux-3':
    case 'veo-3.1':
    case 'veo-3.1-fast':
    case 'kling-2.5-turbo':
    case 'ltx-2.3-fast':
    case 'luma-ray-2-flash':
      return 'render';
    default:
      return null;
  }
};

// Human-facing stage name, Claude-Code style: "Motion check" (cheap validator pass)
// vs "Final render" (expensive SOTA pass). null for non-video / unmapped models.
export const videoLoopStageLabel = (modelId: string | null | undefined): string | null => {
  const tier = videoLoopTier(modelId);
  return tier === 'motion' ? 'Motion check' : tier === 'render' ? 'Final render' : null;
};
